import { ANY_OBJECT } from '@app/interfaces/interfaces';
import { capitalize } from '@app/utils/utils';

export const expandedColumns: Array<ANY_OBJECT> = [
  {
    title: 'roles.table.key',
    dataIndex: 'id',
    width: 'auto',
    editable: false,
    align: 'center' as const,
    render: (_text: string, _record: ANY_OBJECT, index: number) => index + 1,
  },
  {
    title: 'roles.table.permission',
    dataIndex: 'title',
    width: 'auto',
    inputType: 'text',
    editable: false,
    render: (text: string) => text && capitalize(text),
  },
  {
    title: 'roles.table.readOnly',
    dataIndex: 'readOnly',
    width: 'auto',
    inputType: 'checkbox',
    align: 'center' as const,
    editable: true,
    render: (text: number) => (text ? '✅' : '❌'),
  },
  {
    title: 'roles.table.readAndWrite',
    dataIndex: 'readAndWrite',
    width: 'auto',
    inputType: 'checkbox',
    align: 'center' as const,
    editable: true,
    render: (text: number) => (text ? '✅' : '❌'),
  },
];
